import { AI_BASE_URL } from "../config";
import { getUserDeviceId } from "../lib/helper-functionts";

/**
 * Fetches Twilio access token for voice calls
 * @returns Promise with access token string
 * @throws Error if token fetch fails or token is missing
 */
export async function getTwilioAccessToken(): Promise<string> {
  const url = `${AI_BASE_URL}/voices/twilio/token/device`;
  const userDeviceId = getUserDeviceId();

  const res = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "user-device-id": userDeviceId,
    },
  });

  if (!res.ok) {
    throw new Error(`Token endpoint failed: ${res.status}`);
  }
  
  const json = await res.json();
  const token = json?.token || json?.accessToken || json?.twilioAccessToken;
  
  if (!token) {
    throw new Error("No access token in response");
  }
  
  return token;
}

